import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from "../services/authentication.service";
import { first, tap } from "rxjs/operators";
import { NavigationService } from "@/core/services/navigation.service";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  public constructor(
    private readonly _navigator: NavigationService,
    private readonly _authenticationService: AuthenticationService,
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._authenticationService.loggedIn$.pipe(
      tap(loggedIn => {
        if (!loggedIn) {
          this._navigator.navigateToLogin();
        }
      }),
      first(),
    );
  }
}
